<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <input
      v-bind="field"
      type="date"
      :name="name"
      :id="name"
      :placeholder="placeholder"
      :disabled="disabled"
      class="block w50 px-4 py-3 border rounded leading-4 h-10"
      :class="{ 'border-danger': errorMessage }"
      @blur="onChange"
      @change="onChange"
    />

    <BaseErrorMessage v-if="errorMessage" :message="errorMessage" />
  </div>
</template>

<script>
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    BaseFormLabel,
    BaseErrorMessage,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped></style>
